const OTHER_IMMIGRATION_DOCUMENTS = [
    {
        text: 'ssap.input.label.orr_certification',
        name: 'orrcertificationIndicator'
    },
    {
        text: 'ssap.input.label.orr_eligibility_letter',
        name: 'orreligibilityLetterIndicator'
    },
    {
        text: 'ssap.input.label.cuban_haitian_entrant',
        name: 'cubanHaitianEntrantIndicator'
    },
    {
        text: 'ssap.input.label.american_samoan',
        name: 'americanSamoanIndicator'
    },
    {
        text: 'ssap.input.label.domestic_violence',
        name: 'domesticViolence'
    },
    {
        text: 'ssap.input.label.indian_of_us_or_canada',
        name: 'indianOfUsOrCanada'
    },
    {
        text: 'ssap.input.label.withholding_of_removal',
        name: 'withholdingOfRemovalIndicator'
    }
];

const MN_OTHER_IMMIGRATION_DOCUMENTS = [
    {
        text: 'ssap.input.label.deportation_withheld_ina',
        name: 'deportationWithheldInaIndicator'
    },
    {
        text: 'ssap.input.label.refugee',
        name: 'refugeeIndicator'
    },
    {
        text: 'ssap.input.label.special_iraqi_afghani_immigrant',
        name: 'specialIraqiAfghaniImmigrantIndicator'
    },
    {
        text: 'ssap.input.label.victim_severe_trafficking',
        name: 'victimSevereTraffickingIndicator'
    },
    {
        text: 'ssap.input.label.conditional_entrant',
        name: 'conditionalEntrantIndicator'
    },
    {
        text: 'ssap.input.label.lawful_permanent_resident',
        name: 'lawfulPermanentResidentIndicator'
    },
    {
        text: 'ssap.input.label.paroled_at_least_one_year',
        name: 'paroledAtLeastOneYearIndicator'
    },
    {
        text: 'ssap.input.label.temporary_nonimmigrant',
        name: 'temporaryNonimmigrantIndicator'
    },
    {
        text: 'ssap.input.label.deferred_action_childhood_arrivals',
        name: 'deferredActionChildhoodArrivalsIndicator'
    },
    {
        text: 'ssap.input.label.amerasian_noncitizen',
        name: 'amerasianNoncitizenIndicator'
    },
    {
        text: 'ssap.input.label.asylee',
        name: 'asyleeIndicator'
    }
];

const COFA_MIGRANT_OPTION = {
    text: 'ssap.input.label.cofa_migrant',
    name: 'cofaMigrantIndicator'
};

const MN_OTHER_OPTION = {
    text: 'ssap.input.label.other',
    name: 'otherIndicator'
};

const NONE_OF_THESE_OPTION = {
    text: 'ssap.input.label.none_of_these_other',
    name: 'noneOfTheseOther'
};


export const getAllDocumentsList = (isState) => {
    const baseDocuments = [...OTHER_IMMIGRATION_DOCUMENTS];

    // Add MN-specific options only for Minnesota
    if (isState?.MN) {
        baseDocuments.push(...MN_OTHER_IMMIGRATION_DOCUMENTS);
        baseDocuments.push(COFA_MIGRANT_OPTION);
        baseDocuments.push(MN_OTHER_OPTION);
    } else {
        baseDocuments.push(COFA_MIGRANT_OPTION);
    }

    baseDocuments.push(NONE_OF_THESE_OPTION);

    return baseDocuments;
};